import { render } from "./bbCRMSurtogateFile.vue?vue&type=template&id=47d597d0"
import script from "./bbCRMSurtogateFile.vue?vue&type=script&lang=js"
export * from "./bbCRMSurtogateFile.vue?vue&type=script&lang=js"

import "./bbCRMSurtogateFile.vue?vue&type=style&index=0&id=47d597d0&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__